export const environment = {
  production: false,
  env: 'dev',
  // Which "Sign in with ..." buttons the login and sign-up pages show. Only Google is switched on in the Firebase
  // project (Authentication > Sign-in method); turn the others on here once they are.
  socialLogins: { google: true, facebook: false, apple: false },
  apiUrls: {
    // api: 'https://www.collectagift.com',
  
     api: 'https://mongopay.collectagift.com',
    // api:'http://localhost:3302'
  },
  stripePK:
    'pk_test_51HpL7FEmO2b7uwYz5Axfk0O2yJQnwr9faCwH6BKeIe3G6I72AxXDi5t7WU95g42QtAeQHKK1ayQL9C8H1tRs1TSW00Vy4odoHl',
  stripePayoutLink:
    'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_KOXeiV2keir8uUdBmn9xzNjaYu9lGHSk&scope=read_write',
  firebaseConfig: {
    apiKey: 'AIzaSyDpIXUPNhMdkqIMqiHPmYCIKJLDkuKZlpk',
    authDomain: 'collectagift-3b895.firebaseapp.com',
    databaseURL: 'https://collectagift-3b895-default-rtdb.firebaseio.com',
    projectId: 'collectagift-3b895',
    storageBucket: 'collectagift-3b895.appspot.com',
    messagingSenderId: '329689445810',
    appId: '1:329689445810:web:160a8ae7ea6cec93bca0ab',
    measurementId: 'G-PGY8DDR4CQ',
  },
};
